var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMpDiamanteCobalto({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Modo_de_aislamiento",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12.95 19.53",
    style: {
      enableBackground: "new 0 0 12.95 19.53"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4A0E81;}\n\t.st1{fill:#0E19A3;}\n\t.st2{fill:#B48A38;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.47,19.53L0,9.77L6.47,0l6.47,9.77L6.47,19.53z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpDiamanteCobalto);
export default __webpack_public_path__ + "static/media/mp-diamante-cobalto.314e90061ad4a3efaf0d326c6b97b6f6.svg";
export { ForwardRef as ReactComponent };